import _classCallCheck from "/codebuild/output/src2989845404/src/tpp-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src2989845404/src/tpp-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/codebuild/output/src2989845404/src/tpp-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src2989845404/src/tpp-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/codebuild/output/src2989845404/src/tpp-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * DevExtreme (esm/core/templates/function_template.js)
 * Version: 21.2.5
 * Build date: Mon Jan 17 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { TemplateBase } from "./template_base";
import { normalizeTemplateElement } from "../utils/dom";
export var FunctionTemplate = /*#__PURE__*/function (_TemplateBase) {
  _inherits(FunctionTemplate, _TemplateBase);

  function FunctionTemplate(render) {
    var _this;

    _classCallCheck(this, FunctionTemplate);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FunctionTemplate).call(this));
    _this._render = render;
    return _this;
  }

  _createClass(FunctionTemplate, [{
    key: "_renderCore",
    value: function _renderCore(options) {
      return normalizeTemplateElement(this._render(options));
    }
  }]);

  return FunctionTemplate;
}(TemplateBase);